import {PPRequest} from '@gongxigames/framework/integrations/pariplay/request/PPRequest';
import {PPPlaceBetResponse} from '@gongxigames/framework/integrations/pariplay/response/PPPlaceBetResponse';
import {Xhr} from '@gongxigames/framework/slot';

export class PPNotificationRequest extends PPRequest<PPPlaceBetResponse> {
    protected getURL(): string {
        return this.config.RgsUrl + '/client/' + this.config.NotifyUrl;
    }

    protected send(): void {
        this.browser.addTimeout(() => {
            Xhr.postWithFields(this.getURL(), this.getParams(), (body: any) => {
                this.callback(body);
            }, PPRequest.HEADERS, this.getRequestCredentials());
        }, PPRequest.SLOW_REQUEST_TIMEOUT);

    }

    protected getParams(): string {
        const data: any = {};

        data.PlayerTokenId = this.config.playerTokenID;

        return Xhr.objectToKeyValue(data);
    }
}
